import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { LinhaProducaoService } from '@app/modules/linha_producao/services/linha_producao.service';
import { ModeloService } from '@app/modules/modelos/services/modelo.service';
import { VendedorService } from '@app/modules/vendedor/services/vendedor.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { convertDateToMaskTimezone } from '@app/shared/utils';
import {
  DashboardData,
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';
import { PreCadastroService } from '../../../../modules/cliente/services/pre_cadastro.service';
import { IDashboardInfo } from '../../model/dashboard.model';
import { DashboardInfoService } from '../../service/dashboard.service';
import { DialogDashboardFiltrosComponent } from '../dialog-dashboard-filtros/dialog-dashboard-filtros.component';

@Component({
  selector: 'dashboard-info',
  templateUrl: './dashboard-info.component.html',
  styleUrls: ['./dashboard-info.component.scss'],
  providers: [
    LinhaProducaoService,
    PreCadastroService,
    ModeloService,
    VendedorService
  ]
})
export class DashboardInfoComponent implements OnInit, AfterViewInit {
  public keywordFormDateRange = new UntypedFormControl();
  public keywordFormDateRangeStart = new UntypedFormControl();
  public keywordFormDateRangeEnd = new UntypedFormControl();
  public linhaProducaoControl = new UntypedFormControl();
  public preCadastroControl = new UntypedFormControl();
  public vendedorControl = new UntypedFormControl();
  public modeloControl = new UntypedFormControl();

  dashboardData: DashboardData[] = [];
  maxDate = new Date();
  minDateField = new Date(new Date().setDate(new Date().getDate() - 90));
  minDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  viewInit = false;
  linhaProdId: string;
  mock_default = {
    registro: {
      qtd_pedidos: 0,
      qtd_itens: 0
    },
    analise: {
      qtd_pedidos: 0,
      qtd_itens: 0
    },
    processo: {
      qtd_pedidos: 0,
      qtd_itens: 0
    },
    concluido: {
      qtd_pedidos: 0,
      qtd_itens: 0
    },
    cancelado: {
      qtd_pedidos: 0,
      qtd_itens: 0
    }
  };

  constructor(
    public dialog: MatDialog,
    public router: Router,
    public matSnackBar: MatSnackBar,
    protected dashboardService: DashboardInfoService,
    public linhaProducaoService: LinhaProducaoService,
    public preCadastroService: PreCadastroService,
    public vendedorService: VendedorService,
    public modeloService: ModeloService,
    public tokenService: TokenService
  ) {}

  ngAfterViewInit(): void {
    this.viewInit = true;
  }

  public ngOnInit() {
    this.keywordFormDateRange.setValue([this.minDate, this.maxDate]);
    this.keywordFormDateRangeStart.setValue(this.minDate);
    this.keywordFormDateRangeEnd.setValue(this.maxDate);
    this.onSearch();
  }

  protected onLoad() {
    this.dashboardService
      .getValuesDashboard(this.linhaProducaoControl.value.id)
      .subscribe({
        next: (value: IDashboardInfo) => {
          this.dashboardData = [];
          if (value.indices.length === 0) value.indices.push(this.mock_default);
          value.indices.forEach(valor => {
            Object.keys(valor).forEach(chave => {
              this.dashboardData.push({
                icon: this.getStatsOfKeys(chave, 'icon'),
                showPopUp: false,
                statistic_data:
                  typeof valor[chave] === 'object' &&
                  valor[chave] !== null &&
                  Object.keys(valor[chave]).length > 0
                    ? this.getStatsOfTitle(valor[chave], false)
                    : null,
                title: this.getStatsOfKeys(chave, 'title'),
                subtitle:
                  typeof valor[chave] === 'object' &&
                  valor[chave] !== null &&
                  Object.keys(valor[chave]).length > 0
                    ? 'e um total de ' +
                      this.getStatsOfTitle(valor[chave], true) +
                      ' peças'
                    : null,
                style: {
                  background_color_card: 'white',
                  border_style_card: '1px solid var(--primary-color)',
                  icon_color: 'var(--primary-color)',
                  text_color_card: 'var(--primary-color)',
                  title_color: 'var(--primary-color)',
                  subtitle_color: 'var(--primary-color)'
                },
                statistic_result: null,
                overviewChartData: null,
                overviewChartOptions: null
              });
            });
          });
        },
        error: (err: HttpErrorResponse) => {
          this.displayError(err);
        }
      });
  }

  onSearch() {
    var valueDateStart = convertDateToMaskTimezone(
      this.keywordFormDateRangeStart.value
    );
    var valueDateEnd = convertDateToMaskTimezone(
      this.keywordFormDateRangeEnd.value
    );

    this.dashboardService
      .filtrarPorDatas(
        valueDateStart,
        valueDateEnd,
        this.linhaProducaoControl.value?.id,
        this.preCadastroControl.value?.id,
        this.modeloControl.value?.id,
        this.vendedorControl.value?.id
      )
      .subscribe({
        next: value => {
          this.dashboardData = [];
          if (value.indices.length === 0) value.indices.push(this.mock_default);
          value.indices.forEach(valor => {
            Object.keys(valor).forEach(chave => {
              this.dashboardData.push({
                icon: this.getStatsOfKeys(chave, 'icon'),
                showPopUp: false,
                statistic_data:
                  typeof valor[chave] === 'object' &&
                  valor[chave] !== null &&
                  Object.keys(valor[chave]).length > 0
                    ? this.getStatsOfTitle(valor[chave], false)
                    : null,
                title: this.getStatsOfKeys(chave, 'title'),
                subtitle:
                  typeof valor[chave] === 'object' &&
                  valor[chave] !== null &&
                  Object.keys(valor[chave]).length > 0
                    ? 'e um total de ' +
                      this.getStatsOfTitle(valor[chave], true) +
                      ' peças'
                    : null,
                style: {
                  background_color_card: 'white',
                  border_style_card: '1px solid var(--primary-color)',
                  icon_color: 'var(--primary-color)',
                  text_color_card: 'var(--primary-color)',
                  title_color: 'var(--primary-color)',
                  subtitle_color: 'var(--primary-color)'
                },
                statistic_result: null,
                overviewChartData: null,
                overviewChartOptions: null
              });
            });
          });
        },
        error: (err: HttpErrorResponse) => {
          this.displayError(err);
        }
      });
  }

  getStatsOfTitle(obj, subtitle: boolean) {
    var stats = 0;
    var statsSub = 0;
    Object.keys(obj).forEach(key => {
      if (key.includes('qtd_itens') && subtitle) statsSub = obj[key];
      if (!key.includes('qtd_itens')) stats = obj[key];
    });
    return subtitle ? statsSub : stats;
  }

  getStatsOfKeys(chave: string, type: string) {
    if (chave === 'analise')
      return type === 'icon'
        ? 'mdi mdi-account-clock'
        : 'Pedidos pendentes de uma analise';
    else if (chave === 'registro')
      return type === 'icon' ? 'mdi mdi-pencil-outline' : 'Registro de pedidos';
    else if (chave === 'processo')
      return type === 'icon'
        ? 'pi pi mdi mdi-timer-cog-outline'
        : 'Pedidos que estão em produção';
    else if (chave === 'concluido')
      return type === 'icon'
        ? 'mdi mdi-checkbox-marked-circle-auto-outline'
        : 'Pedidos já concluidos';
    else if (chave === 'cancelado')
      return type === 'icon'
        ? 'mdi mdi-close-circle-outline'
        : 'Pedidos que foram cancelados';
    else if (chave === 'pendente_em_producao')
      return type === 'icon'
        ? 'pi pi-fw pi-clock'
        : 'Pedidos pendentes em produção';
    else return '';
  }

  openDialogFilters() {
    this.dialog
      .open(DialogDashboardFiltrosComponent, {
        data: {
          linhaProducaoControl: this.linhaProducaoControl,
          modeloControl: this.modeloControl,
          preCadastroControl: this.preCadastroControl,
          vendedorControl: this.vendedorControl,
          keywordFormDateRange: this.keywordFormDateRange,
          keywordFormDateRangeStart: this.keywordFormDateRangeStart,
          keywordFormDateRangeEnd: this.keywordFormDateRangeEnd
        },
        position: {
          top: '0px'
        },
        panelClass: ['custom-container', 'position-relative']
      })
      .afterClosed()
      .subscribe(response => {
        if (response) {
          if (response.clear) this.onClearFiltros();
          else {
            this.linhaProducaoControl.setValue(
              response.linhaProducaoControl.value
            );
            this.modeloControl.setValue(response.modeloControl.value);
            this.preCadastroControl.setValue(response.preCadastroControl.value);
            this.vendedorControl.setValue(response.vendedorControl.value);
            this.keywordFormDateRange.setValue(
              response.keywordFormDateRange.value
            );
            this.keywordFormDateRangeStart.setValue(
              response.keywordFormDateRangeStart.value
            );
            this.keywordFormDateRangeEnd.setValue(
              response.keywordFormDateRangeEnd.value
            );
            this.onSearch();
          }
        }
      });
  }

  onClearFiltros() {
    this.linhaProducaoControl.reset();
    this.modeloControl.reset();
    this.preCadastroControl.reset();
    this.vendedorControl.reset();
    this.keywordFormDateRange.setValue([this.minDate, this.maxDate]);
    this.keywordFormDateRangeStart.setValue(this.minDate);
    this.keywordFormDateRangeEnd.setValue(this.maxDate);
    this.onSearch();
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.dialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            icon: 'warning',
            bodyMessage: txtMsg,
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.checkError();
  }
}
